// test1965
(1965 && 0);
